import {ReactNode} from "react";

interface TitleAndContentProps {
    title: string | ReactNode,
    content: (string | ReactNode) | (string | ReactNode)[],
}

function TitleAndContent({title, content}: TitleAndContentProps) {
    return (
        <>
            <h2 className="static-content__title">
                {title}
            </h2>
            {Array.isArray(content) ? (
                <>
                    {content.map((c) => (
                        <p className="static-content__description">
                            {c}
                        </p>
                    ))}
                </>
            ) : (
                <p className="static-content__description">
                    {content}
                </p>
            )}
        </>
    )
}

export default TitleAndContent;